import React, { useState } from 'react'
import Portal from '../portal/portal';
import emojiAlegre from '../../layout/img/emojis/alegre.png';
import emojiTriste from '../../layout/img/emojis/triste.png';
import { numberAleatori } from '../../helpers';

export const GraficoHeatmapProduto = ({
  id, 
  grafico, 
  semdadosparaexibir, 
    customHint=false, 
  hint=false,
  cy,
  tag={
    lista: 'listaDeProdutosIndicador',
    descricao: 'descricaoIndicador',
  }
}) => {
  const [hintVisivel, sethintVisivel] = useState('');
  const [hintData, setHintData] = useState(null);

  const invisible = (e) => {
    let div = document.getElementById("root-grafico-hint");
    if (!div) return;
    
    let children = div.childNodes;
    for (let i = 0; i < children.length; i++) {
      if (children[i].className.includes(e)) {
        children[i].style.display = "block";
      } else {
        children[i].style.display = "none";
      }
    }
  }

  const openHint = (e, n) => {
    invisible(`graficotablehint-${id}`)
    if (e) {
      let div = e.target;
      let rect = div.getBoundingClientRect(),
        eixoR = rect.right,
        eixoX = rect.left,
        eixoY = rect.top,
        width = rect.width,
        height = rect.height;
        let windowWidth = window.innerWidth;
        let windowHeight = window.innerHeight;

      let coor = { left: eixoX , top: eixoY + height + 1 };

      if (Math.ceil(eixoY + height) + 300 >= windowHeight) {
        coor = {...coor, bottom: windowHeight - eixoY, top: 'auto' };
      } 
      if (Math.ceil(eixoX + width) + 300 >= windowWidth) {
        coor = {...coor, right: eixoR - eixoX, left: 'auto' };
      } 

      setHintData({
        coor: coor,
        width: width,
        name: n.name,
        x: n.x,
        y: n.y
      });
      sethintVisivel(true);
    }
  };

  const closeHint = () => {
    sethintVisivel(false);
    setHintData(null);
  };

  const icoReference = (value) => {
    if (value === 'positivo') {
      return <img src={emojiAlegre} title='Alegre' />
    }
    return <img src={emojiTriste} title='Triste' />
  }

    if (!Array.isArray(grafico) || grafico.length === 0 || !grafico[0]?.[tag.lista]?.length) {
    return (
      <div
        data-cy={cy ? `${cy}-empty` : undefined}
        className='pageloadview-message'
      >
        {semdadosparaexibir}
      </div>
    );
  }
  
  return grafico[0]?.[tag.lista]?.length ? (
        <div 
      id={`grafico-heatmap-${id}`}
      data-cy={cy ? `${cy}-heatmap` : undefined}
      data-cy-id={cy ? id : undefined}
      className="box-graficos-heatmap"
      onMouseLeave={closeHint}
    >
      <table className='grafico-table-head'>
        <tbody>
          <tr className='grafico-table-header'>
            <td></td>
            <td></td>
          </tr>
          {
            grafico?.map(e=> {
                            return (
                <tr
                  key={`grafico-table-head-${e[tag.descricao]}`}
                  data-cy={cy ? `${cy}-label` : undefined}
                  data-cy-id={
                    cy &&
                    e?.indicadorId !== undefined &&
                    e?.indicadorId !== null
                      ? e.indicadorId
                      : undefined
                  }
                >
                  <td className='grafico-table-head-ico'>{icoReference(e.sinal)}</td>
                  <td className='grafico-table-head-name'>{e[tag.descricao]}</td>
                </tr>
              )
            })
          }
        </tbody>
      </table>
      <div className='grafico-table-scroll'>
        <table className='grafico-table-content'>
          <tbody>
            <tr className='grafico-table-header'>
              {
                                grafico?.[0][tag.lista]?.map(d=> (
                  <td
                    key={`grafico-table-header-${d.produtoId}`}
                    data-cy={cy ? `${cy}-column` : undefined}
                    data-cy-id={
                      cy &&
                      d?.lojaId !== undefined &&
                      d?.lojaId !== null
                        ? d.lojaId
                        : undefined
                    }
                  >
                    {d.descricao}
                  </td>
                ))
              }
            </tr>
            {
              grafico?.map(grafic=> {
                                return (
                  <tr
                    key={`grafico-table-content-${grafic[tag.descricao]}`}
                    data-cy={cy ? `${cy}-row` : undefined}
                    data-cy-id={
                      cy &&
                      grafic?.indicadorId !== undefined &&
                      grafic?.indicadorId !== null
                        ? grafic.indicadorId
                        : undefined
                    }
                  >
                  {
                    grafic?.[tag.lista].map(produto=> {
                                            return <td 
                        key={`grafico-table-content-item--${numberAleatori(99999999)}`}
                        data-cy={cy ? `${cy}-cell` : undefined}
                        data-cy-indicator-id={
                          cy &&
                          grafic?.indicadorId !== undefined &&
                          grafic?.indicadorId !== null
                            ? grafic.indicadorId
                            : undefined
                        }
                        data-cy-column-id={
                          cy &&
                          produto?.lojaId !== undefined &&
                          produto?.lojaId !== null
                            ? produto.lojaId
                            : undefined
                        }
                        data-cy-value={
                          cy &&
                          produto?.qtdeIndicador !== undefined &&
                          produto?.qtdeIndicador !== null
                            ? produto.qtdeIndicador
                            : undefined
                        }
                        style={{backgroundColor: produto.codigoCor, borderColor: produto.codigoCor}}
                        onMouseEnter={(ev)=> openHint(ev, {name: grafic[tag.descricao], x: produto.descricao, y: produto.qtdeIndicador}, `hint-${produto.produtoId}`)}
                        onMouseOut={closeHint} // ← ALTERE ESTA LINHA
                      >
                      </td>
                    })
                  }
                </tr>
                                )
              })
            }
          </tbody>
        </table>
      </div>
      {
        hint && hintVisivel && hintData ? (
          <Portal name={`grafico-hint`}>
            <div 
              className={`grafico-table-hint graficotablehint-${id}`} 
              style={{ 
                ...hintData.coor, 
                position: 'fixed', // ← MUDEI para fixed para melhor controle
                minWidth: hintData.width,
                zIndex: 1000 
              }}
            >
              <label>{hintData.x}</label>
              {customHint ? (
                <span>{hintData.name}: <strong>{hintData.y}</strong></span>
              ) : (
                <span>{hintData.name}</span>
              )}
            </div>
          </Portal>
        ) : null
      }
    </div>
    ) : (
    <div
      data-cy={cy ? `${cy}-empty` : undefined}
      className='pageloadview-message'
    >
      {semdadosparaexibir}
    </div>
  )
}